import { DownloadDetail } from '../domain/download-detail.model';
import { DownloadDetailApiModel } from '../infrastructure/download-detail-api.model';

export const mapDownloadDetailApiModelToDomain = (
  apiModel: DownloadDetailApiModel
): DownloadDetail => {
  return {
    id: apiModel.ID,
    createdAt: apiModel.CreatedAt,
    updatedAt: apiModel.UpdatedAt,
    deletedAt: apiModel.DeletedAt ?? null,
    activityPlatformId: apiModel.activityPlatformId,
    pathPOD: apiModel.pathPOD,
    allVinsConfirmed: apiModel.allVinsConfirmed,
    createdBy: apiModel.createdBy,
    updatedBy: apiModel.updatedBy,
  };
};

export const mapDownloadsDetailApiModelToDomainArray = (
  apiModels: DownloadDetailApiModel[]
): DownloadDetail[] => {
  return apiModels.map(mapDownloadDetailApiModelToDomain);
};
